module.exports = __webpack_public_path__ + "img/Subhead-bg.ec4bcb83.png";